import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowForward = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "icon/navigation/arrow_forward_ios_24px",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "icon/navigation/arrow_forward_ios_24px_2",
				d: "M6.16406 20.1301L7.93406 21.9001L17.8341 12.0001L7.93406 2.1001L6.16406 3.8701L14.2941 12.0001L6.16406 20.1301H6.16406Z",
				fill: "#fad504"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0",
				"mask-type": "alpha",
				maskUnits: "userSpaceOnUse",
				x: 6,
				y: 2,
				width: 12,
				height: 24,
				children: /* @__PURE__ */ _jsx("path", {
					id: "icon/navigation/arrow_forward_ios_24px_3",
					d: "M6.16406 20.1301L7.93406 21.9001L17.8341 12.0001L7.93406 2.1001L6.16406 3.8701L14.2941 12.0001L6.16406 20.1301H6.16406Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", { mask: "url(#mask0)" })
		]
	})]
});
const ForwardRef = forwardRef(SvgArrowForward);
export default ForwardRef;
